export default __webpack_public_path__ + "static/media/SvgIcons.b4f537db.svg";